module.exports = __webpack_public_path__ + "img/wall_tech_Normal_ua.45de64ab.webp";